import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import TextArea from "../../components/shared/TextArea";
import DateField from "../../components/shared/DateField";


const PaymentRequestsAddPage = () => {

    const {t,i18n} = useTranslation();
    useDocumentTitle('أمر دفع جديد');
    const navigate = useNavigate();
    const pageTitle = {title: 'أمر دفع جديد', subTitle: 'يمكنك إضافة أمر دفع للمستفيدين من هنا.'};
    const EmptyAddPaymentRequestForm = {
        title: '',
        type: "rent",
        amount: '',
        createdBy: {},
        description: '',
        beneficiaryIds: [],
        dueDate: '',
        isRecurring: '',
        recurrence: {
            frequency: "",
            repeat: ""
        }
    };
    const [addPaymentRequestForm,setAddPaymentRequestForm] = useState(EmptyAddPaymentRequestForm);
    const [errors, setErrors] = useState(null);
    const [isAddPaymentRequestFormDisabled, setIsAddPaymentRequestFormDisabled] = useState(true);

    const [allUsers, setAllUsers] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [userData, setUserData] = useState(null);

    const handleSubmitAddPaymentRequest = async () => {
        setIsAddPaymentRequestFormDisabled(true);
        const finalAddPaymentRequestForm = JSON.parse(JSON.stringify(addPaymentRequestForm));
        finalAddPaymentRequestForm.amount = parseInt(finalAddPaymentRequestForm.amount);
        if(finalAddPaymentRequestForm?.isRecurring === false) {
            delete finalAddPaymentRequestForm.recurrence;
        }
        try {
        const response = await apiClient.post(`/b-payment-requests`,finalAddPaymentRequestForm);
        if(response?.data || response?.status === 201) {
            navigate(`/ar/payment-requests`);
        } else {
            setIsAddPaymentRequestFormDisabled(false);
        }
        } catch(err) {
            setIsAddPaymentRequestFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }


    useEffect(()=>{
        if(addPaymentRequestForm 
            && addPaymentRequestForm?.title && addPaymentRequestForm?.title !== ''
            && addPaymentRequestForm?.description && addPaymentRequestForm?.description !== ''
            && addPaymentRequestForm?.beneficiaryIds && Array.isArray(addPaymentRequestForm?.beneficiaryIds) && addPaymentRequestForm?.beneficiaryIds?.length > 0
            && addPaymentRequestForm?.dueDate && addPaymentRequestForm?.dueDate !== ''
            && addPaymentRequestForm?.isRecurring !== ''
            ) {
                setIsAddPaymentRequestFormDisabled(false);
                if(addPaymentRequestForm?.isRecurring) {
                    if(addPaymentRequestForm?.recurrence?.frequency && addPaymentRequestForm?.recurrence?.frequency !== ''
                        && addPaymentRequestForm?.recurrence?.repeat && addPaymentRequestForm?.recurrence?.repeat !== '') {
                            setIsAddPaymentRequestFormDisabled(false);
                        } else {
                            setIsAddPaymentRequestFormDisabled(true);
                        }
                }  else {
                    setIsAddPaymentRequestFormDisabled(false);
                }
        } else {
            setIsAddPaymentRequestFormDisabled(true);
        }
    },[addPaymentRequestForm])


    const useRolesOptions = [
        {label:'المدراء', value:'ADMINISTRATOR'},
        {label:'الموظفين', value:'EMPLOYEE'},
        {label:'المستفيدين', value:'BENEFICIARY'}
    ]

    const getAllUsers = async () => {
      try {
        const response = await apiClient.get(`/b-users`);
        if(response?.data) {
          setAllUsers(response?.data?.filter(user =>  user?.role?.id === 'BENEFICIARY').map(user => ({label: user?.name, value: user?._id})));
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        getAllUsers();
    },[])



    const TrueOrFalseOptions = [
        {label:'نعم', value: true},
        {label:'لا', value: false},
    ]

    const frequencyOptions = [
        {label:'أسبوعي', value: 'weekly'},
        {label:'شهري', value: 'monthly'},
        {label:'ربع سنوي', value: 'quarterly'},
        {label:'نصف سنوي', value: 'semi-annually'},
        {label:'سنوي', value: 'yearly'},
    ]

    const EndAfterOptions = [
        {label:'2 مرة', value: 2},
        {label:'3 مرة', value: 3},
        {label:'4 مرة', value: 4},
        {label:'5 مرة', value: 5},
        {label:'6 مرة', value: 6},
        {label:'7 مرة', value: 7},
        {label:'8 مرة', value: 8},
        {label:'9 مرة', value: 9},
        {label:'10 مرة', value: 10},
        {label:'11 مرة', value: 11},
        {label:'12 مرة', value: 12}
    ]

    const handleGetUser = (user) => {
        setUserData(user);
        setAddPaymentRequestForm({ ...addPaymentRequestForm, createdBy: user?._id });
    }
    

    return (
        <div>
        <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
        <PageMain>
            <span className="fixed top-0 left-0 right-0 bottom-0 z-[-1] bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإرسال أمر دفع جديد." label="أضف أمر دفع جديد ">
                    
                    <div className="mb-[15px]">
                        <InputField label={'عنوان أمر الدفع'} placeholder={'اكتب عنوان أمر الدفع'} value={addPaymentRequestForm?.title} error={errors?.title} errorMessage={errors?.title} translateError={true} onChange={(e)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm, title: e.target.value }); hideError('title')}} />
                    </div>

                    <div className="mb-[15px] relative">
                        <InputField label={'المبلغ'} placeholder={'اكتب المبلغ هنا'} value={addPaymentRequestForm?.amount} error={errors?.amount} errorMessage={errors?.amount} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setAddPaymentRequestForm({ ...addPaymentRequestForm, amount: e.target.value }) }; hideError('amount')}} />
                        <span className="absolute top-[41px] end-[15px] w-[13px] h-[13px]" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'السبب'} placeholder={'اكتب سبب أمر الدفع هنا ان وجد'} value={addPaymentRequestForm?.description} error={errors?.description} errorMessage={errors?.description} translateError={true} onChange={(e)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm, description: e.target.value }); hideError('description')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'اسماء المستفيدين'} placeholder={'اختر أسماء المستفيدين هنا'} isMulti options={allUsers} error={errors?.beneficiaryIds} errorMessage={errors?.beneficiaryIds} value={addPaymentRequestForm?.beneficiaryIds} onChange={(options)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm, beneficiaryIds: options?.map(option => option?.value) }); hideError('beneficiaryIds')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ الاستحقاق'} today placeholder={'اكتب تاريخ الاستحقاق هنا'} value={addPaymentRequestForm?.dueDate} error={errors?.dueDate} errorMessage={errors?.dueDate} translateError={true} onChange={(date)=>{ setAddPaymentRequestForm({ ...addPaymentRequestForm, dueDate: date, installationDate: date }); hideError('dueDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'التكرار'} placeholder={'اختر إذا كان أمر الدفع سيكرر أم لا '} options={TrueOrFalseOptions} error={errors?.isRecurring} errorMessage={errors?.isRecurring} value={addPaymentRequestForm?.isRecurring} onChange={(option)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm, isRecurring: option?.value }); hideError('isRecurring')}} />
                    </div>

                    {addPaymentRequestForm?.isRecurring && <>
                        <div className="mb-[15px]">
                            <MultiSelect label={'معدل التكرار'} placeholder={'اختر معدل التكرار '} options={frequencyOptions} error={errors?.frequency} errorMessage={errors?.recurrence?.frequency} value={addPaymentRequestForm?.recurrence?.frequency} onChange={(option)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm, recurrence: { ...addPaymentRequestForm.recurrence, frequency: option?.value } }); hideError('frequency')}} />
                        </div>

                        <div className="mb-[15px]">
                            <MultiSelect label={'ينتهي بعد'} placeholder={'اختر عدد مرات التكرار '} options={EndAfterOptions} error={errors?.endAfter} errorMessage={errors?.recurrence?.repeat} value={addPaymentRequestForm?.recurrence?.repeat} onChange={(option)=>{setAddPaymentRequestForm({ ...addPaymentRequestForm,  recurrence: { ...addPaymentRequestForm.recurrence, repeat: option?.value }}); hideError('endAfter')}} />
                        </div>

                    </>}



                    

                    <div className="text-end">
                        <NormalButton label={'ارسال أمر الدفع'} onClick={handleSubmitAddPaymentRequest} isDisabled={isAddPaymentRequestFormDisabled} />
                    </div>

                </NormalFormContainer>
            </MainContent>
        </PageMain>
        </div>
    )

}

export default PaymentRequestsAddPage;